import { RecommenderRequestDto } from '../dtos/recommender-request-dto.js';
import { RequestHelper, IResponseWithData } from "../libs/request-helper";
import { SpinnerHelper } from '../libs/spinner-helper';
import { RecommenderResponseDto } from "../dtos/recommender-response-dto";
import { RecommenderDto } from '../dtos/recommender-dto.js';
import { RecommenderWidget } from '../widgets/recommender-widget';
import { FilterBarDock } from '../filter-bar-dock';

declare var THOR: any;

export class RecommenderRenderer {
	protected static REQUEST_URL = "/wp-content/themes/enfold-schauspielhaus/json/recommender.php";

	protected static request: RecommenderRequestDto;
	protected static lastDate: Date | null;
	protected static recommenderId?: string | undefined;
	private static recommenderContainer:HTMLElement
	private static typeOfRecommendations: string
	private static productionId: string | null

	protected static async init(typeOfRecommendations: string, productionId: string | null): Promise<void> {
		RecommenderRenderer.lastDate = null;
		document.addEventListener('DOMContentLoaded', RecommenderRenderer.onDocumentLoaded, false);
		RecommenderRenderer.request = {};
		RecommenderRenderer.typeOfRecommendations = typeOfRecommendations
		RecommenderRenderer.productionId = productionId;
	}

	protected static async onDocumentLoaded() {
		RecommenderRenderer.recommenderContainer = document.getElementById("recommenderContainer");

		RecommenderRenderer.renderSpinner()
		SpinnerHelper.startSpinning();

		//fake recommendations
		// const testRec = ['172535432', '172811752', '173166209']
		// RecommenderRenderer.recommenderId = 'dkagfbhkaf-hgkdshjg-5667567'
		// RecommenderRenderer.request.recommendations = testRec
		// RecommenderRenderer.loadData()

		//real recommendations
		const response = await THOR.Main.getRecommendations(RecommenderRenderer.typeOfRecommendations, 3, "30", RecommenderRenderer.productionId)

		if(response){
			RecommenderRenderer.recommenderId = response.recoId;
			RecommenderRenderer.request.recommendations = response.results;
			RecommenderRenderer.loadData();
		} else {
			SpinnerHelper.stopSpinning();
			RecommenderRenderer.recommenderContainer.classList.add("hide");
			FilterBarDock.update()
		}
	}

	private static async loadData() {
		var response = await RequestHelper.postJsonAndSpin<RecommenderResponseDto>(RecommenderRenderer.REQUEST_URL, RecommenderRenderer.request);
		var data = <RecommenderResponseDto>response.data;
		let recommendations = data.recommendations;
		SpinnerHelper.stopSpinning();
		if (recommendations.length >= 3) {
			RecommenderRenderer.renderRecommender(data)
			RecommenderWidget.init();
		} else {
			RecommenderRenderer.recommenderContainer.classList.add("hide");
			FilterBarDock.update()
		}
	}

	private static renderSpinner(){
		let recommenderContainer = document.getElementById("recommenderContainer");

		var spinnerContainer = document.createElement("div");
		spinnerContainer.classList.add("_spinnerContainer");

		var spinner= document.createElement("div");
		spinner.classList.add("spinner");
		spinnerContainer.appendChild(spinner);
		recommenderContainer.appendChild(spinnerContainer);
	}

	private static setupCloseButton(parent: HTMLElement) {
		var closeButton = document.createElement("div");
		closeButton.classList.add("_recommenderClose");
		closeButton.classList.add("icon-close");

		closeButton.addEventListener('click', function () {
			const currentHeight = RecommenderRenderer.recommenderContainer.scrollHeight;
			// set the current height as max-height to animate the height
			RecommenderRenderer.recommenderContainer.style.maxHeight = currentHeight + 'px';
			RecommenderRenderer.recommenderContainer.classList.add("hideVisually");
			setTimeout(function () {
				RecommenderRenderer.recommenderContainer.classList.add("hide");
			}, 800);

		})

		parent.appendChild(closeButton);

	}

	private static renderRecommender(recommendationData: RecommenderResponseDto) {

		let recommendations = recommendationData.recommendations;

		RecommenderRenderer.renderRecommenderContainer();

		for (var _i = 0; _i < recommendations.length; _i++) {
			var event = recommendations[_i];
			RecommenderRenderer.renderEvent(event);
		}
	}

	private static renderRecommenderContainer() {

		RecommenderRenderer.recommenderContainer.classList.add("_recommenderContainer");

		// title container
		var recommenderTitleContainer = document.createElement("div");
		recommenderTitleContainer.classList.add("_recommenderTitleContainer");

		// title
		var recommenderTitle = document.createElement("div");
		recommenderTitle.classList.add('headline4')
		recommenderTitle.innerHTML = "Unsere Empfehlungen für Sie"

		recommenderTitleContainer.appendChild(recommenderTitle);

		// close button
		RecommenderRenderer.setupCloseButton(recommenderTitleContainer);

		RecommenderRenderer.recommenderContainer.appendChild(recommenderTitleContainer);

		// carousel
		var latteCarousel = document.createElement("div");
		latteCarousel.classList.add("latte-carousel");
		latteCarousel.setAttribute("id", "carousel");
		RecommenderRenderer.recommenderContainer.appendChild(latteCarousel);

	}

	private static renderEvent(rec: RecommenderDto) {
		let carouselContainer = document.getElementById("carousel");

		// latte item
		var newLatteItem = document.createElement("div");
		newLatteItem.classList.add("latte-item");

		// image
		var imageContainer = document.createElement("div");
		imageContainer.classList.add("imageContainer");
		var imageLink = document.createElement("a");
		imageLink.href = "/produktion/" + rec.produktion +  "?recoId=" + RecommenderRenderer.recommenderId


		var recommendationImage = document.createElement("img");
		recommendationImage.src = rec.image
		recommendationImage.alt = rec.altTag;
		recommendationImage.title = rec.altTag;

		imageLink.appendChild(recommendationImage)
		imageContainer.appendChild(imageLink)

		// ticketContainer
		var ticketContainer = document.createElement("a");

		// The ticket link may already contain search parameters so the URL class is used to append the recoId
		var ticketLink = new URL(rec.ticket);
		ticketLink.searchParams.append("recoId", RecommenderRenderer.recommenderId)
		ticketContainer.href = ticketLink.href;

		ticketContainer.target = "_blank";
		ticketContainer.classList.add("ticketContainer");

		var date = document.createElement("div");
		date.classList.add('ticketDay')
		var splitted = rec.beginDate.split(".");
		date.innerHTML = splitted[0]
		ticketContainer.appendChild(date);

		var month = document.createElement("div");
		month.classList.add('ticketMonth')
		month.innerHTML = splitted[1]
		ticketContainer.appendChild(month);

		imageContainer.appendChild(ticketContainer);

		newLatteItem.appendChild(imageContainer)

		// textContainer
		var textContainer = document.createElement("div");
		textContainer.setAttribute("class", "textContainer");
		newLatteItem.appendChild(textContainer);

		// title
		var title = document.createElement("a");
		title.setAttribute("href", "/produktion/" + rec.produktion +  "?recoId=" + RecommenderRenderer.recommenderId);
		title.classList.add('headline3')
		title.innerHTML = rec.name

		textContainer.appendChild(title);

		// addition1
		var description1 = document.createElement("div");
		description1.classList.add('text1')
		description1.innerHTML = rec.addition1

		textContainer.appendChild(description1);

		// addition2
		var description2 = document.createElement("div");
		description2.classList.add('text1')
		description2.innerHTML = rec.addition2

		textContainer.appendChild(description2);

		carouselContainer.appendChild(newLatteItem);
	}

}